import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import SantanderReportDetail from './ReferencedPayments/SantanderReportDetail';
import AutomaticDebitCollectionsView from '../automaticDebitCollection';
import ReportsView from './ReportsView';

const SantanderReportsView = () => (
  <Routes>
    <Route path="referenced-payments/detail/:reportId/*" element={<RolePrivateRoute component={SantanderReportDetail} />} />
    <Route path="automatic-debit-collections/:tab" element={<RolePrivateRoute component={AutomaticDebitCollectionsView} />} />
    <Route path="automatic-debit-collections" element={<RolePrivateRoute component={AutomaticDebitCollectionsView} />} />
    <Route path=":tab" element={<RolePrivateRoute component={ReportsView} />} />
    <Route index element={<Navigate to="referenced-payments" replace />} />
  </Routes>
);

export default SantanderReportsView;
